import { render, staticRenderFns } from "./TaskAssignedTeam.vue?vue&type=template&id=18f6a1da&"
import script from "./TaskAssignedTeam.vue?vue&type=script&lang=js&"
export * from "./TaskAssignedTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f6a1da')) {
      api.createRecord('18f6a1da', component.options)
    } else {
      api.reload('18f6a1da', component.options)
    }
    module.hot.accept("./TaskAssignedTeam.vue?vue&type=template&id=18f6a1da&", function () {
      api.rerender('18f6a1da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskAssignedTeam.vue"
export default component.exports